import React, {
  PropsWithChildren,
} from 'react';
import clsx from 'clsx';

type Part = 'root' | 'container';

type Props = PropsWithChildren & {
  className?: string;
  classes?: Partial<Record<Part, string>>;
};

export default function PanelExtension({
  classes,
  className,
  children,
}: Props) {
  return (
    <div className={clsx(
      'populate-panel-extension h-full transition-width duration-150 ease-in-out overflow-hidden',
      className,
      classes?.root,
    )}
    >
      <div className={clsx('h-full w-full', classes?.container)}>
        {children}
      </div>
    </div>
  );
}
